import React from "react";

import CalculationField from "@components/Calculator/CalculationField/calculationField.component";
import { Col } from "@components/General/Grid/col.component";
import { Row } from "@components/General/Grid/row.component";

import "./areaField.scss";

type Props = {
    id: string;
    index: number;
    updateValues: any;
    name?: string;
    isLength?: boolean;
    values: any;
};

const AreaField = ({
    id,
    index,
    updateValues,
    name,
    isLength,
    values,
}: Props) => {
    const calculationPropsX = {
        name: "width",
        dimension: "width",
        unit: "m",
        setCalculationValue: (_: string, value: string) =>
            updateValues(index, [values[0], value]),
        sm: 4,
        md: 4,
    };

    const calculationPropsY = {
        name: isLength ? "length" : "height",
        dimension: isLength ? "length" : "height",
        unit: "m",
        setCalculationValue: isLength
            ? (_: string, value: string) =>
                  updateValues(index, [value, values[1]])
            : (_: string, value: string) =>
                  updateValues(index, [value, values[1]]),
        sm: 4,
        md: 4,
    };

    return (
        <Row id={id} className={"mb-3"}>
            {name && (
                <Col sm={12}>
                    <h4 className={"mb-0"}>
                        {name} {index + 1}
                    </h4>
                </Col>
            )}
            <CalculationField {...calculationPropsY} value={values[0]} />
            <CalculationField {...calculationPropsX} value={values[1]} />
            <Col sm={3} md={3} className={"calculator-wallpaper-area"}>
                <span>
                    {(values[0] * values[1])
                        .toFixed(2)
                        .toString()
                        .replace(".", ",")}{" "}
                    m<sup>2</sup>
                </span>
            </Col>
        </Row>
    );
};

export default AreaField;
